export default __webpack_public_path__ + "static/media/agriculturainteligente.b258c02f.svg";